<template>
  <div>
    <div class="candidate-navbar" style="background-color: #3b425d">
      <a
        type="button"
        style="background-color: #22c59a; color: #fff"
        href="javascript:void(0)"
        @click.prevent="openOnBoardModal()"
      >
        確認報到
      </a>
      <a type="button" href="javascript:void(0)" @click.prevent="$router.go(-1)"
        >返回</a
      >
    </div>

    <div class="step-page">
      <h3 class="mb-3 text-center" style="color: #fff">報到資料</h3>

      <ValidationObserver ref="observer">
        <el-tabs v-model="activeName" tab-position="left" class="tab-component">
          <el-tab-pane label="圖檔繳交" name="圖檔繳交">
            <div class="step-content" style="background: transparent">
              <Images :key="key" :MatchId="MatchId" />
            </div>
          </el-tab-pane>

          <el-tab-pane
            v-if="showIncomeTaxReturn"
            key="incomeTax"
            label="免稅額申報表"
            name="免稅額申報表"
          >
            <div class="step-content" style="background: white">
              <IncomeTax />
            </div>
          </el-tab-pane>

          <el-tab-pane
            v-for="(item, index) in contracts"
            :key="item.ContractVersionGuid"
            :label="item.ContractName"
            :name="item.ContractName"
          >
            <div class="step-content" style="background: #fff">
              <div style="padding: 15px">
                <div class="contract-title">{{ item.ContractTitle }}</div>
                <div v-html="item.ContractContent" />

                <table class="w-100">
                  <tr>
                    <th id="date">簽署日期</th>
                    <td>
                      {{
                        item.SignedTime
                          ? $common.dateFormatter(item.SignedTime)
                          : $common.getToday()
                      }}
                    </td>
                  </tr>

                  <tr>
                    <td style="width: 112px;">簽章</td>
                    <td colspan="3" v-show="item.SignedPicBase64">
                      <img
                        style="
                          width: 400px;
                          height: 200px;
                          border: 2px solid rgb(215, 215, 215);
                        "
                        :src="item.SignedPicBase64"
                        alt=""
                      />
                      <el-button size="mini" @click="resigned(index)"
                        >重簽</el-button
                      >
                    </td>
                    <td colspan="3" v-show="!item.SignedPicBase64">
                      <VueSignature
                        class="signaturePad"
                        :id="`signature${index}`"
                        style="border: 2px solid #d7d7d7"
                        :ref="`signature${index}`"
                        :defaultUrl="item.SignedPicBase64 || ''"
                        :w="'400px'"
                        :h="'200px'"
                      />
                      <el-button size="mini" @click="clear(index)"
                        >清除</el-button
                      >
                    </td>
                  </tr>
                </table>

                <div style="text-align: center">
                  <el-button
                    type="primary"
                    size="small"
                    class="mt-2"
                    @click="downloadPDF(item.ContractVersionGuid)"
                  >
                    下載 PDF
                  </el-button>
                  <el-button
                    size="small"
                    class="mt-2 save-btn"
                    @click="saveContract(index)"
                  >
                    儲存
                  </el-button>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </ValidationObserver>
    </div>

    <!-- 確認報到 Modal -->
    <div
      id="checkOnBoardModal"
      class="modal fade"
      tabindex="-1"
      data-backdrop="static"
    >
      <div class="modal-dialog">
        <img class="cord" src="@/assets/img/name_card_cord.png" alt="" />
        <ValidationObserver ref="reported" v-slot="{ handleSubmit, reset }">
          <form @reset.prevent="reset">
            <div class="modal-content">
              <div class="modal-header">
                <span>完成報到</span>
              </div>
              <div class="modal-body">
                <div class="info">
                  <div class="text-wrap">
                    <div class="name">{{ person.Name }}</div>
                    <div class="position">{{ person.Position }}</div>
                  </div>
                </div>
                <div class="state-wrap">
                  <ValidationProvider
                    tag="div"
                    rules="required"
                    class="w-100"
                    v-slot="{ errors }"
                  >
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="radio"
                        :value="0"
                        v-model="person.OnBoardStatus"
                      />
                      <label for="" class="form-check-label"> 待報到 </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="radio"
                        :value="1"
                        v-model="person.OnBoardStatus"
                      />
                      <label for="" class="form-check-label"> 完成報到 </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="radio"
                        :value="-99"
                        v-model="person.OnBoardStatus"
                      />
                      <label for="" class="form-check-label"> 取消報到 </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="radio"
                        :value="-1"
                        v-model="person.OnBoardStatus"
                      />
                      <label for="" class="form-check-label"> 延期報到 </label>
                    </div>
                    <p class="text-danger" style="font-size: 13px">
                      {{ errors[0] }}
                    </p>
                  </ValidationProvider>
                </div>
                <div
                  v-if="
                    person.OnBoardStatus === 1 || person.OnBoardStatus === -1
                  "
                  class="number-wrap"
                >
                  <ValidationProvider
                    tag="div"
                    rules="required"
                    name="報到日期"
                    class="w-100"
                    v-slot="{ errors }"
                  >
                    <el-date-picker
                      class="w-100"
                      type="date"
                      value-format="yyyy-MM-dd"
                      :picker-options="{
                        disabledDate: $common.disabledDateBeforeToday,
                      }"
                      placeholder="請選擇日期"
                      v-model="person.NewOnBoardDate"
                    />
                    <span class="text-danger" style="font-size: 13px">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </div>
                <div v-else-if="person.OnBoardStatus === -99">
                  <ValidationProvider
                    tag="div"
                    rules="required"
                    name="原因"
                    class="w-100"
                    v-slot="{ errors }"
                  >
                    <el-cascader
                      class="w-100"
                      :options="notArrivedCategoryOptions"
                      clearable
                      :show-all-levels="true"
                      placeholder="請選擇原因"
                      v-model="person.notArrivedCategory"
                    />
                    <p class="text-danger" style="font-size: 13px">
                      {{ errors[0] }}
                    </p>
                  </ValidationProvider>
                  <textarea
                    class="form-control w-100"
                    type="text"
                    rows="3"
                    maxlength="200"
                    placeholder="請輸入備註"
                    v-model="person.OnBoardRemark"
                  />
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="reset"
                  class="btn btn-secondary"
                  aria-label="關閉"
                  data-dismiss="modal"
                >
                  取消
                </button>
                <button
                  type="button"
                  class="btn btn-success"
                  @click="handleSubmit(confirmedOnBoard)"
                >
                  確認
                </button>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
/* global $ */
import { mapActions } from "vuex";
import Images from "@/components/back/CandidateData/PersonalDocument/Images";
import IncomeTax from "@/components/back/CandidateData/PersonalDocument/IncomeTax";

export default {
  name: "PersonalData",

  components: {
    Images,
    IncomeTax,
  },
  data() {
    return {
      key: 0,
      MatchId: null,
      activeName: "圖檔繳交",
      collapseName: null,

      showIncomeTaxReturn: false,

      // 合約清單
      contracts: [],
      // 合約 Guid
      ContractVersionGuid: null,
      // 簽名圖檔(Base64)
      SignedPicBase64: null,

      //前一頁帶過來的人員資料
      person: null,
    };
  },

  methods: {
    // 重簽
    resigned(index) {
      this.contracts[index].SignedPicBase64 = null;
      this.clear(index);
    },

    // 儲存 合約
    saveContract(index) {
      // 以實際筆畫判斷，isEmpty() 在 fromDataURL 後會被設為 false，無法判斷是否有簽名
      const pad = this.$refs[`signature${index}`][0];
      if (!pad || pad.sig.toData().length === 0) {
        // 沒有新筆畫但已有簽名(未重簽)，沿用原簽名
        if (!this.contracts[index].SignedPicBase64) {
          this.$notify({
            title: "失敗",
            message: "尚未簽名",
            type: "error",
            duration: 3500,
          });
          return;
        }
        this.SignedPicBase64 = this.contracts[index].SignedPicBase64;
      } else {
        this.SignedPicBase64 = pad.save();
      }

      this.ContractVersionGuid = this.contracts[index].ContractVersionGuid;

      this.updateLoading(true);
      this.$api.contract
        .putContract({
          MatchId: this.MatchId,
          ContractVersionGuid: this.ContractVersionGuid,
          SignedPicBase64: this.SignedPicBase64,
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.status === 200) {
              this.$notify({
                title: "成功",
                message: "儲存成功",
                type: "success",
                duration: 2500,
              });
              // 只更新剛儲存的合約，避免覆蓋其他分頁尚未儲存的重簽狀態
              this.getContract(this.ContractVersionGuid);
            }
          }
          this.updateLoading(false);
        });
    },

    // 取得 合約（有傳 ContractVersionGuid 時只更新該份合約）
    async getContract(ContractVersionGuid) {
      this.ContractVersionGuid = null;
      this.SignedPicBase64 = null;
      this.updateLoading(true);
      await this.$api.contract.getContract(this.MatchId).then((response) => {
        if (response.status === 200) {
          const contracts = response.data.map((item) => {
            return {
              ...item,
              SignedTime: item.SignedTime
                ? this.$common.dateFormatter(item.SignedTime)
                : this.$common.getToday(),
            };
          });

          const index = this.contracts.findIndex(
            (item) => item.ContractVersionGuid === ContractVersionGuid
          );
          const updated = contracts.find(
            (item) => item.ContractVersionGuid === ContractVersionGuid
          );
          if (ContractVersionGuid && index > -1 && updated) {
            this.contracts.splice(index, 1, updated);
          } else {
            this.contracts = contracts;
          }
        }
        this.updateLoading(false);
      });
    },

    // 下載 合約 PDF
    downloadPDF(ContractVersionGuid) {
      this.updateLoading(true);
      this.$api.contract
        .downloadContractPDF({
          MatchId: this.MatchId,
          ContractVersionGuid: ContractVersionGuid,
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.type === "application/json") {
              let reader = new FileReader();
              reader.readAsText(response.data, "utf-8");
              reader.onload = () => {
                const { ErrorMessage } = JSON.parse(reader.result);
                this.$notify({
                  title: "失敗",
                  message: ErrorMessage,
                  type: "error",
                  duration: 3500,
                });
              };
            } else {
              let fileName = decodeURIComponent(
                decodeURIComponent(
                  response.headers["content-disposition"].split(
                    "filename*=UTF-8''"
                  )[1]
                )
              );
              let blob = new Blob([response.data], { type: "application/pdf" });
              let url = window.URL.createObjectURL(blob);
              let a = document.createElement("a");
              a.href = url;
              a.download = fileName;
              a.click();
              window.URL.revokeObjectURL(url);
            }
          }
          this.updateLoading(false);
        });
    },

    // 簽名板 清除
    clear(index) {
      this.$refs[`signature${index}`][0].clear();
    },

    // 報到確認 Modal
    async openOnBoardModal() {
      // 取得 報到未到分類選項
      const notArrivedCategory = await this.$api.onBoard.getNotArrivedCategory(
        this.MatchId
      );
      this.notArrivedCategoryOptions = notArrivedCategory.data.map(
        (category) => {
          return {
            value: category.Guid,
            label: category.Name,
            children: category.Children.map((children) => {
              return {
                value: children.Guid,
                label: children.Name,
              };
            }),
          };
        }
      );

      // 取得 報到狀態資訊
      const status = await this.$api.onBoard.getOnBoardStatus(this.MatchId);
      this.person = {
        MatchId: this.MatchId,
        Name: this.person.Name,
        Position: this.person.Position,
        ...status.data,
        notArrivedCategory: [
          status.data.NotArrivedCategoryGuid,
          status.data.NotArrivedCategorySecondGuid,
        ],
        NewOnBoardDate: status.data.OnBoardTime
          ? status.data.OnBoardTime.split("T")[0]
          : null,
      };

      this.$refs.reported.reset();
      $("#checkOnBoardModal").modal("show");
    },

    // 報到確認
    confirmedOnBoard() {
      $("#checkOnBoardModal").modal("hide");
      this.updateLoading(true);
      this.$api.recruitment
        .onBoard({
          MatchId: this.MatchId,
          OnBoardStatus: this.person.OnBoardStatus,
          EmployeeNo:
            this.person.OnBoardStatus === 1 ? this.person.EmployeeNo : null,
          NewOnBoardDate: this.person.NewOnBoardDate,
          OnBoardRemark: this.person.OnBoardRemark,
          NotArrivedCategoryGuid:
            this.person.notArrivedCategory.length > 0
              ? this.person.notArrivedCategory[0]
              : null,
          NotArrivedCategorySecondGuid:
            this.person.notArrivedCategory.length > 0
              ? this.person.notArrivedCategory[1]
              : null,
        })
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              title: "成功",
              message: "確認成功",
              type: "success",
              duration: 2500,
            });
          }
          this.updateLoading(false);
        });
    },

    // 是否需要填寫 免稅額申報表
    getIncomeTaxReturn() {
      this.$api.incomeTax
        .getRequiredIncomeTaxReturn(this.MatchId)
        .then((response) => {
          if (response.status === 200) {
            this.showIncomeTaxReturn = response.data;
          }
        });
    },

    // loading
    ...mapActions(["updateLoading"]),
  },

  watch: {
    activeName: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.key++;
      }
    },
  },

  created() {
    this.MatchId = this.$route.query.matchId;
    this.person = JSON.parse(this.$route.query.personData);
    this.getIncomeTaxReturn();
    this.getContract();
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  },
};
</script>

<style lang="scss" scoped>
.step-content {
  max-width: 100%;
  padding: 0 15px 0 15px;
  margin-bottom: 30px;
  .contract-title {
    text-align: center;
    font-size: 1em;
    font-weight: bold;
    letter-spacing: 10px;
  }
  .sign-date {
    input {
      border-radius: 10px;
      margin-left: 10px;
    }
  }
  .sign-name {
    position: relative;
    margin: 15px 0 15px 0;
    width: 100%;
    img {
      position: relative;
      left: 50%;
      transform: translate(-50%);
      width: 800px;
      height: 400px;
    }
    .signaturePad {
      margin: auto;
      border: double 3px;
      border-radius: 5px;
      border-radius: 10px;
      border-color: #b0b0b0;
      background-origin: border-box;
      background-clip: content-box, border-box;
    }
  }
  .sign-button {
    text-align: center;
    button {
      border-color: #b0b0b0;
    }
  }

  th {
    font-weight: normal;
  }
}

/deep/.el-collapse-item__header {
  padding-left: 20px;
  font-weight: bold !important;
}
.field-title {
  .en-text {
    opacity: 0.6;
    font-size: 0.85em;
    margin-left: 5px;
  }
}
.step-tip {
  color: #fff;
  font-size: 0.85em;
}

/deep/ .el-tabs__content {
  &::-webkit-scrollbar {
    width: 7px;
  }

  &::-webkit-scrollbar-button {
    background: transparent;

    border-radius: 4px;
  }

  &::-webkit-scrollbar-track-piece {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 4px;

    background-color: rgba(0, 0, 0, 0.4);

    border: 1px solid slategrey;
  }

  &::-webkit-scrollbar-track {
    box-shadow: transparent;
  }

  @media screen and (min-width: 768px) {
    height: calc(100vh - 175px);
    overflow: auto;
  }
}

/deep/ .tab-component {
  .el-tabs__item {
    color: #fff;
    width: 150px;
    line-height: unset;
    height: auto;
    white-space: normal;
    text-align: left;
    padding-top: 10px;
    padding-bottom: 10px;

    &.is-active {
      color: #22c59a;
    }
  }

  .el-tabs__active-bar {
    background-color: #22c59a;
  }

  .important-table {
    width: 90%;
    max-width: 680px;
    margin: 0 auto;

    th {
      color: #fff;
      padding: 10px;
      text-align: center;
    }
    td {
      padding: 10px;
      input,
      select {
        border: none;
        border-radius: 25px;
        width: 100%;
        line-height: 30px;
        height: 30px;
        padding: 0 10px;
      }
    }
  }
}

.save-btn {
  background: #22c59a;
  border: none;
  color: #fff;
}

/deep/ .el-input--prefix .el-input__inner {
  padding-left: 30px !important;
}

/deep/.el-input__prefix,
.el-input__suffix {
  top: -4px !important;
}

/deep/ .el-range-editor {
  border: none;
  height: 30px;
  border-radius: 25px;

  .el-range__icon {
    top: -5px;
    position: relative;
  }
  .el-range-separator {
    line-height: 25px;
  }
}

ol.EmploymentContract {
  counter-reset: item;
  li {
    display: block;
    text-indent: -14px;
  }
  li:before {
    content: counters(item, ".") " ";
    counter-increment: item;
  }
}

/deep/ ul.pare {
  list-style: none;
  & > li {
    /* 使用自訂標號 */
    counter-increment: my-counter; /* 段落首行縮排 */
    &::before {
      content: "(" counter(my-counter) ")";
      margin-left: -24px;
    }
  }
}

/deep/ table.border {
  width: 100%;
  td {
    border: 1px solid #000 !important;
  }
}

#checkOnBoardModal .modal-dialog {
  .modal-content {
    padding-top: 30px;
    .modal-header {
      display: block;
    }
    .modal-body {
      max-height: calc(100vh - 200px);
      .info {
        margin-bottom: 15px;
        .text-wrap {
          margin-top: 70px;
        }
      }
      .state-wrap {
        padding-bottom: 0;
      }
    }
  }
}
</style>
